import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { importEvents } from 'gqlQueries/promoRecommendation';
import { notification } from 'antd';
import { sendNotification } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useImportEvent(fetchEventsList: any, selectedPlan: any, triggerNotification = false) {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>([]);
    const [editType, setEditType] = useState('add');
    //To fetch dim
    const [fetchImportList, { data: EventResponse, loading: EventResponseLoading, error: EventResponseError }] =
        useMutation(importEvents, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    useEffect(() => {
        setLoading(EventResponseLoading);
    }, [EventResponseLoading]);

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            setData(() => payload);
            if (triggerNotification) {
                sendNotification('success', 'Event Successfully Imported.');
            }
            fetchEventsList({
                variables: {
                    planId: selectedPlan?.planId,
                },
            });
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setLoading(false);
        setError(error);
        sendNotification('error', 'Something went wrong!');
    }

    return {
        loading,
        error,
        data,
        fetchImportList: (variables: any) => {
            fetchImportList(variables);
            setEditType(variables.variables.operationType);
        },
        onFetchComplete,
    };
}

export default useImportEvent;
